import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { InfluencerCloseSVG } from "@/Component/Common/SVGs/CommonSVG";
import InfluencerDetail from "@/Component/Common/InfluencerDetail";
import { setCurrentSidebarTab, setInfluencerToCampaign } from "@/lib/Features/UserDetailSidebar/userDetailSidebar";
import usePost from "@/Utils/Hooks/usePost";
import { CampaignAPI } from "@/Utils/APIRequest/Endpoints";

const SidebarModal = (props) => {
    const { openSideModal, setOpenSideModal, ref, setIsComponentVisible, translations, scrollRef, setPoolActiveTab, filteredValue, setFilteredValue, setRestrictModalOpen, campaignDetailData, isSeen } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentSidebarTab(openSideModal ? true : false))
    }, [openSideModal])

    const clickOut = () => {
        setIsComponentVisible((prev) => false)
        setOpenSideModal(null)
    }

    return (
        <>
            <div ref={ref} className={`z-[63] fixed top-0 right-0 2xl:w-2/3 xl:w-4/5 w-full h-full bg-white shadow-lg transform transition-all ${openSideModal ? 'translate-x-0' : 'translate-x-full transition-all'}`} >
                <div className="absolute top-5 left-5 text-black font-bold z-10 cursor-pointer" onClick={clickOut}>
                    <InfluencerCloseSVG /></div>
                <div className="h-screen lg:p-16 p-4 !pt-12 w-full overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 relative transition-all">
                    {(openSideModal?.slug ?? openSideModal?.influencer?.slug) && <InfluencerDetail slug={openSideModal?.slug ? openSideModal?.slug : openSideModal?.influencer?.slug} key={openSideModal?.slug ? openSideModal?.slug : openSideModal?.influencer?.slug} translations={translations} setOpenSideModal={setOpenSideModal} scrollRef={scrollRef} openSideModal={openSideModal} setPoolActiveTab={setPoolActiveTab} filteredValue={filteredValue} setFilteredValue={setFilteredValue} setRestrictModalOpen={setRestrictModalOpen} campaignDetailData={campaignDetailData} isSeen={isSeen} />}
                </div>
            </div>
            {openSideModal && <div onClick={clickOut} className='z-[61] fixed before:fixed before:top-0 before:left-0 before:w-full before:h-full before:bg-black/50'></div>}
        </>
    );
}

export default SidebarModal;
